import ma1stScience from "./ma1stScienceQuizContent";
import ma1stSocialStudies from "./ma1stSocialStudiesQuizContent";
import ma1stMath from "./ma1stMathQuizContent";
import ma1stOther from "./ma1stOtherQuizContent";

// 2nd Grade
import ma2ndScience from "./ma2ndScienceQuizContent";
import ma2ndSocialStudies from "./ma2ndSocialStudiesQuizContent";
import ma2ndMath from "./ma2ndMathQuizContent";
import ma2ndOther from "./ma2ndOtherQuizContent";

// 3rd Grade
import ma3rdScience from "./ma3rdScienceQuizContent";
import ma3rdSocialStudies from "./ma3rdSocialStudiesQuizContent";
import ma3rdMath from "./ma3rdMathQuizContent";
import ma3rdOther from "./ma3rdOtherQuizContent";

// 4th Grade
import ma4thScience from "./ma4thScienceQuizContent";
import ma4thSocialStudies from "./ma4thSocialStudiesQuizContent";
import ma4thMath from "./ma4thMathQuizContent";
import ma4thOther from "./ma4thOtherQuizContent";

// 5th Grade
import ma5thScience from "./ma5thScienceQuizContent";
import ma5thSocialStudies from "./ma5thSocialStudiesQuizContent";
import ma5thMath from "./ma5thMathQuizContent";
import ma5thOther from "./ma5thOtherQuizContent";
// ...import the rest as you add them

// Keep your existing keys ← these are what MapPage already uses
export const matopicsMapBySubject = {
  // 1st Grade
  ma_1st_science: ma1stScience,
  ma_1st_socialstudies: ma1stSocialStudies,
  ma_1st_math: ma1stMath,
  ma_1st_other: ma1stOther,

  // 2nd Grade
  ma_2nd_science: ma2ndScience,
  ma_2nd_socialstudies: ma2ndSocialStudies,
  ma_2nd_math: ma2ndMath,
  ma_2nd_other: ma2ndOther,

  // 3rd Grade
  ma_3rd_science: ma3rdScience,
  ma_3rd_socialstudies: ma3rdSocialStudies,
  ma_3rd_math: ma3rdMath,
  ma_3rd_other: ma3rdOther,

  // 4th Grade
  ma_4th_science: ma4thScience,
  ma_4th_socialstudies: ma4thSocialStudies,
  ma_4th_math: ma4thMath,
  ma_4th_other: ma4thOther,

  // 5th Grade
  ma_5th_science: ma5thScience,
  ma_5th_socialstudies: ma5thSocialStudies,
  ma_5th_math: ma5thMath,
  ma_5th_other: ma5thOther,
  // ...add the rest
};
